<template>
<div class="hero-page green-pattern">
  <v-container fluid-md class="pb-0 pt-5 px-0 py-0">
    <v-layout row wrap fill-height align-center>
        <v-flex
          class="rounded-card title-block mt-5 mb-3"
          xs10
          sm5
          md5
          lg4
          offset-xs1
          offset-md0
          elevation-19
          text-xs-left
        >
          <v-card
            flat
            class="rounded-card pt-3 px-4"
          >
            <v-card-title primary-title class="pt-3 pb-0">
              <h1 class="mb-4">
                For Students <br>
                &mdash; By&nbsp;Students
              </h1>
            </v-card-title>
            <v-card-title align-with-title class="grey--text mb-0 py-0">
              <h2 class="mb-4">
                TD Lab
              </h2>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex
          class="hero-illustration-container mb-5 pb-5 mt-3"
          xs10
          sm5
          md7
          offset-xs1
          offset-sm0
        >
          <hero-illustration />
        </v-flex>
        <v-flex
          class="read-more-button pb-5 mt-5 mb-5"
          xs10
          md3
          offset-xs1
          text-md-left
        >
            <a href="#" v-scroll-to="'#about'">
              <h4>Read More</h4>
              <readArrow/>

              <div class="circle"></div>
            </a>

        </v-flex>
    </v-layout>

  </v-container>
</div>
</template>

<style lang="scss">
.hero-page {
  position: relative;
  top: -88px;
  left: 0;
  right: 0;
  overflow: hidden;
  &::after {
    content: ' ';
    position: absolute;
    top: 50%;
    left: 0;
    width: 150%;
    height: 100%;
    background: white;
    z-index: 0;
    transform: rotate(-13deg);
    box-shadow: 0 0 34px 0 rgba(0,0,0,0.6);
  }
  .hero-illustration-container, .title-block, .read-more-button {
    z-index: 1;
  }
  .hero-illustration-container {
    transform: scale(1.125) translateY(15%);
    margin-bottom: 70px !important;
  }

  .read-more-button {
    * {
      transition: all 0.25s ease;
    }
    font-size: 24px;
    a {
      display: block;
      width: 100%;
      height: 100%;
    }
    .readArrow {
      transform: translateX(5px);
    }
    .circle {
      width: 40px;
      height: 40px;
      display: inline-block;
      margin: 2px;
      border-radius: 50%;
      position: relative;
      overflow: hidden;
      border: solid 3px rgb(52,178,51);
      right: 27px;
      top: 13px
    }
    &:hover {
      .readArrow {
        transform: translateX(100px);
      }
      .circle {
        background-color: rgb(52,178,51);
      }
    }
    margin-top: -58px;
  }

  a {
    text-decoration: none;
    color: black;
  }

  @keyframes side-swipe {
    0%   {
      transform: translateX(0px);
      }
    100% {
      transform: translateX(100px);
      }
  }

  h4 {
      margin-bottom: -6px;
      margin-top: -16px;
    }

  h1 {
    font-size: 34px;
    margin-bottom: 24px;
  }
  h2 {
    font-size: 25px;
  }
  @media only screen and (max-width: 600px) {
    h1 {
      font-size: 30px;
      margin-bottom: 16px;
    }
    h2 {
      font-size: 1.5em;
    }
  }
}
</style>

<script>
import heroIllustration from './heroIllustration.vue'
import readArrow from './heroIllustration/readArrow.vue'

export default {
  name: 'hero',
  components: {
    heroIllustration,
    readArrow
  },
  created () {
    this.$store.dispatch('navSetTransparent', true)
    this.$store.dispatch('navSetDark', true)
  },
  beforeDestroy () {
    this.$store.dispatch('navSetTransparent', false)
  }
}
</script>
